import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/hooks/use-theme";
import type { Theme } from "@/providers/theme-provider";

const CYCLE: Theme[] = ["light", "dark", "system"];

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  function handleClick() {
    const currentIndex = CYCLE.indexOf(theme);
    const next = CYCLE[(currentIndex + 1) % CYCLE.length] as Theme;
    setTheme(next);
  }

  const Icon = theme === "dark" ? Sun : theme === "light" ? Moon : Monitor;

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-[38px] h-[38px] rounded-[10px] border border-sc-glass-border bg-sc-glass backdrop-blur-[10px] flex items-center justify-center text-sc-text-muted cursor-pointer hover:bg-sc-surface-hover transition-all"
      aria-label={`Switch to ${CYCLE[(CYCLE.indexOf(theme) + 1) % CYCLE.length]} mode`}
    >
      <Icon size={16} />
    </button>
  );
}
